/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-popover-menu {
  display: inline-block;
  position: relative;
}
.ux-popover-menu .ux-popover-panel {
  padding: 0 20px;
}
.ux-popover-menu__top-start .ux-popover__container, .ux-popover-menu__bottom-start .ux-popover__container {
  transform: translate(var(--ux-popover-menu-content-offset-start), 0);
}
.ux-popover-menu__top-end .ux-popover__container, .ux-popover-menu__bottom-end .ux-popover__container {
  transform: translate(var(--ux-popover-menu-content-offset-end), 0);
}
.ux-popover-menu__left-start .ux-popover__container, .ux-popover-menu__right-start .ux-popover__container {
  transform: translate(0, var(--ux-popover-menu-content-offset-start));
}
.ux-popover-menu__left-end .ux-popover__container, .ux-popover-menu__right-end .ux-popover__container {
  transform: translate(0, var(--ux-popover-menu-content-offset-end));
}

.ux-popover-menu__toggle {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 40px;
  position: relative;
  width: 40px;
}
.ux-popover-menu__toggle span {
  background: #000;
  border-radius: 100%;
  height: 3px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 3px;
}
.ux-popover-menu__toggle span::before, .ux-popover-menu__toggle span::after {
  background: #131313;
  border-radius: 100%;
  content: "";
  height: 3px;
  left: 50%;
  position: absolute;
  transform: translate(-50%, 0);
  width: 3px;
}
.ux-popover-menu__toggle span::before {
  top: -6px;
}
.ux-popover-menu__toggle span::after {
  top: 6px;
}

.ux-popover-menu__content {
  min-width: 300px;
  padding: var(--ux-popover-menu-content-padding);
}
.ux-popover-menu__content ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
.ux-popover-menu__content li {
  border-bottom: 1px solid var(--ux-popover-menu-border-color);
  cursor: pointer;
  padding: var(--ux-popover-menu-item-padding);
  text-align: left;
}
.ux-popover-menu__content li:last-child {
  border-bottom: 0;
}